import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { BoxModal } from '../../boxModal';
import { toast } from 'react-toastify';
import './cartao-unlockCard-modal.css';
import { InputField } from '../cartao-RequestCard-modal/inputField';
import { useCards } from '../../../hooks/useCards';
import { BsInfoCircleFill } from 'react-icons/bs';

export const ModalUnlockCard = ({ isOpen, onClose, card }) => {
  const [formData, setFormData] = useState({
    lastFourDigits: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [unlockLoader, setUnlockLoader] = useState(false);
  const [error, setError] = useState('');
  const { updateCard } = useCards();

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (error) setError('');
  };

  const handleUnlockCard = async () => {
    if (unlockLoader) return;

    if (formData.newPassword.search(/[a-zA-Z]/) !== -1) {
      setError('A senha deve conter apenas números');
      return;
    }
    if (!formData.lastFourDigits || !formData.newPassword || !formData.confirmPassword) {
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    if (formData.lastFourDigits !== card.lastFour) {
      setError('Os últimos 4 dígitos do cartão não coincidem');
      return;
    }
    try {
      setUnlockLoader(true);
      await updateCard({
        id: card.id,
        password: formData.newPassword,
        blocked: false,
        blockedReason: null,
      });
      onClose();
      toast.success('Cartão desbloqueado com sucesso!');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error('Erro ao desbloquear cartão, Erro: ' + error.response.data.message);
    } finally {
      setUnlockLoader(false);
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      className="change-modal"
      overlayClassName="overlay-change-password-modal"
    >
      <BoxModal
        maxWidth={500}
        title="Desbloqueie seu Cartão"
        close={onClose}
      >
        <div className='request-card-form'>
          <InputField
            label="Últimos 4 dígitos do cartão"
            type="number"
            maxLength="4"
            pattern="[0-9]{4}"
            value={formData.lastFourDigits}
            onChange={(e) => handleInputChange('lastFourDigits', e.target.value)}
            className={error && !formData.lastFourDigits ? 'error mb-3' : 'mb-3'}
            placeholder="Últimos 4 dígitos do cartão"
          />
          <InputField
            label="Senha do cartão (4 dígitos)"
            type="password"
            maxLength="4"
            pattern="[0-9]{4}"
            value={formData.newPassword}
            onChange={(e) => handleInputChange('newPassword', e.target.value)}
            className={error && !formData.newPassword ? 'error mb-3' : 'mb-3'}
          />
          <InputField
            label="Confirme a senha"
            type="password"
            maxLength="4"
            pattern="[0-9]{4}"
            value={formData.confirmPassword}
            onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
            className={error && !formData.confirmPassword ? 'error mb-3' : 'mb-3'}
          />
          {error && <span className="error-message">{error}</span>}
          <div className="alert alert-info d-flex align-items-center">
            <BsInfoCircleFill className="me-2 flex-shrink-0" />
            <div className="small">
              Para começar a usar seu cartão, é necessário realizar o desbloqueio informando os dados abaixo.
            </div>
          </div>
          <div className='d-flex flex-row justify-content-end gap-3'>
            <button
              type="button"
              className="btn btn-outline-secondary m-0"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-success m-0"
              onClick={handleUnlockCard}
              disabled={unlockLoader}
            >
              {unlockLoader ? 'Desbloqueando...' : 'Desbloquear'}
            </button>
          </div>
        </div>
      </BoxModal>
    </ReactModal>
  );
};
